import type {
  ActivitiesConfigVersionFormat,
  InsuranceProduct,
  InsuranceProductVersion,
  ProductVersionFormat,
} from '../../model/model.ts'

import type { FrMrgaPolicyItem, FrMrgaPolicyItemsState } from './fr-mrga-insurance.ts'
import type { FrMrgaPricingVersion } from './fr-mrga-pricing-versions.ts'
import { frMrgaPolicyItems_v1_0_0 } from './v1_0_0/policy-items.ts'
import { frMrgaStaticFilesIds_v1_0_0 } from './v1_0_0/static-files.ts'

export const frMrgaProductName = 'product-fr-mrg-axeria'
export type FrMrgaProductName = typeof frMrgaProductName

type FrMrgaBaseName = 'fr-mrg-axeria'

type FrMrgaProductVersionFormat = ProductVersionFormat<FrMrgaBaseName>

export const frMrgaProductVersions = [
  /**
   * Initial version
   */
  'product-fr-mrg-axeria-1.0.0-2026-09-28',
] as const satisfies FrMrgaProductVersionFormat[]

export type FrMrgaProductVersion = (typeof frMrgaProductVersions)[number]

type FrMrgaStaticFileId = (typeof frMrgaStaticFilesIds_v1_0_0)[number]

type FrMrgaInsuranceProduct = InsuranceProduct<
  FrMrgaProductName,
  FrMrgaBaseName,
  FrMrgaProductVersion,
  FrMrgaPolicyItem,
  FrMrgaStaticFileId,
  FrMrgaPricingVersion,
  ActivitiesConfigVersionFormat<FrMrgaBaseName>,
  FrMrgaPolicyItemsState
>

const frMrgaProduct_v1_0_0 = {
  version: 'product-fr-mrg-axeria-1.0.0-2026-09-28',
  description: 'Initial version of FR-MRGA product',
  policyItems: frMrgaPolicyItems_v1_0_0,
  staticFilesId: [...frMrgaStaticFilesIds_v1_0_0],
  pricingVersion: ['pricing-fr-mrg-axeria-1.0.0-2026-09-28'],
  activitiesConfigVersion: 'activities-config-fr-mrg-axeria-1.0.0-2026-09-28',
} as const satisfies InsuranceProductVersion<
  FrMrgaProductName,
  FrMrgaBaseName,
  FrMrgaProductVersion,
  FrMrgaPolicyItem,
  FrMrgaStaticFileId,
  FrMrgaPricingVersion,
  ActivitiesConfigVersionFormat<FrMrgaBaseName>,
  FrMrgaPolicyItemsState
>

export const frMrgaProduct = {
  id: 'fr-mrga',
  versions: {
    'product-fr-mrg-axeria-1.0.0-2026-09-28': frMrgaProduct_v1_0_0,
  },
} as const satisfies FrMrgaInsuranceProduct
export type FrMrgaProduct = typeof frMrgaProduct
